<script>
import { withMessage, required, length, gte, and, optional } from 'form-validation-manager';
import TiersApi from '@/api/tiers';
import { debounce } from 'lodash';
import { mapActions } from 'vuex';
import cancelablePromise from '../../../utils/cancelable-promise';

export default {
  name: 'SelectionTiers',
  data: () => ({
    form: {
      value: null,
      select: null
    },
    loading: false,
    tiers: null
  }),
  validations: {
    form: {
      value: optional(withMessage(
        and(
          required(),
          length(gte(3))
        ),
        'Veuillez entrer au minimum 3 caratères'
      ))
    }
  },
  watch: {
    'form.value' (val) {
      val && val.length >= 3 && val !== this.form.select && this.search(val);
    }
  },
  methods: {
    ...mapActions({ sessionLogout: 'session/logout', _connectAs: 'user/setConnectedAs', loadTiers: 'user/loadTiers' }),
    submit () { },
    searchTiersApiCall: cancelablePromise(value => TiersApi.searchTiers(value), 'canceled'),
    search: debounce(function (value) {
      this.loading = true;
      this.form.select = null;

      this.searchTiersApiCall(value).then(tiers => {
        if (tiers !== 'canceled') {
          this.tiers = tiers;
          this.loading = false;
          this.$forceUpdate();
        }
      }).catch(err => {
        this.loading = false;
        throw err;
      });
    }, 300),
    validate () {
      this.connectAs(this.form.select.numTiers);
    },
    connectAs (numTiers) {
      this.loading = true;
      this._connectAs(numTiers);
      this.loadTiers().then(() => {
        this.loading = false;
        this.$router.push({ name: 'main.catalog.order_history' });
      });
    }

  }
};
</script>

<template>
  <div class="cnt">
    <h1>Rechercher un adhérent</h1>
    <v-form
      ref="form"
      @submit.prevent="submit"
    >
      <v-text-field
        v-model="form.value"
        :loading="loading"
        label="Nom ou numéro d'adhérent"
        :rules="$fvm.form.value.$errors"
      />

      <v-list :class="{'disabled': loading}">
        <v-list-item-group v-if="tiers && !tiers.length">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Aucun tiers trouvé</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group v-model="form.select">
          <v-list-item
            v-for="_tiers in tiers"
            :key="_tiers.numTiers"
            :value="_tiers"
          >
            <v-list-item-content>
              <v-list-item-title>{{ _tiers.raisonSociale }}</v-list-item-title>

              <v-list-item-subtitle>{{ _tiers.numTiers }} - {{ _tiers.adresse ? _tiers.adresse.ville : '' }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action v-if="isMobile">
              <v-btn
                icon
                @click="connectAs(_tiers.numTiers)"
              >
                <v-icon>
                  mdi-login
                </v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-form>
    <div
      v-if="!isMobile"
      class="actions"
    >
      <v-btn
        :disabled="!form.select"
        @click="validate()"
      >
        Valider
      </v-btn>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.cnt{
  max-width: 600px;
}

.v-list{
  height: 60vh;
  overflow-y: scroll;
  &.disabled{
    opacity: 0.5;
    background-color: #aaa;
    pointer-events: none;
  }
}

.actions{
  margin-top: 2em;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap-reverse;
  justify-content: space-around;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .v-list{
    height: calc(100vh - 365px);
    .actions{
      margin-top: 15px;
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .cnt{
    margin-left: 2.5em;
  }
}

</style>
